import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustIndicator {
  id: string;
  icon: string;
  title: string;
  description: string;
}

const trustIndicators: TrustIndicator[] = [
  {
    id: '1',
    icon: 'ShieldCheckIcon',
    title: '100% Confidential',
    description: 'All communications are protected under strict NDA'
  },
  {
    id: '2',
    icon: 'ClockIcon',
    title: '2-Hour Response',
    description: 'Guaranteed response time during business hours'
  },
  {
    id: '3',
    icon: 'UserGroupIcon',
    title: 'Expert Team',
    description: 'Assigned specialists based on your needs'
  },
  {
    id: '4',
    icon: 'CheckBadgeIcon',
    title: 'No Obligation',
    description: 'Free consultation with zero commitment'
  }
];

const TrustIndicators = () => {
  return (
    <div data-component-id="src/app/contact/components/TrustIndicators.tsx:40:4" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="40" data-component-end-line="59" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20sm%3Agrid-cols-2%20lg%3Agrid-cols-4%20gap-6%22%7D" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {trustIndicators.map((indicator) => (
        <div data-component-id="src/app/contact/components/TrustIndicators.tsx:42:8" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="42" data-component-end-line="57" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-start%20space-x-3%20p-4%20bg-card%20border%20border-border%20rounded-lg%22%7D"
          key={indicator.id}
          className="flex items-start space-x-3 p-4 bg-card border border-border rounded-lg"
        >
          <div data-component-id="src/app/contact/components/TrustIndicators.tsx:46:10" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="46" data-component-end-line="48" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex-shrink-0%20w-10%20h-10%20bg-primary%2F10%20rounded-lg%20flex%20items-center%20justify-center%22%7D" className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon data-component-id="src/app/contact/components/TrustIndicators.tsx:47:12" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="47" data-component-end-line="47" data-component-file="TrustIndicators.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22className%22%3A%22text-primary%22%7D" name={indicator.icon as any} size={20} className="text-primary" />
          </div>
          <div data-component-id="src/app/contact/components/TrustIndicators.tsx:49:10" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="49" data-component-end-line="56" data-component-file="TrustIndicators.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D">
            <h4 data-component-id="src/app/contact/components/TrustIndicators.tsx:50:12" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="50" data-component-end-line="52" data-component-file="TrustIndicators.tsx" data-component-name="h4" data-component-content="%7B%22elementName%22%3A%22h4%22%2C%22className%22%3A%22text-sm%20font-heading%20font-semibold%20text-foreground%20mb-1%22%7D" className="text-sm font-heading font-semibold text-foreground mb-1">
              {indicator.title}
            </h4>
            <p data-component-id="src/app/contact/components/TrustIndicators.tsx:53:12" data-component-path="src/app/contact/components/TrustIndicators.tsx" data-component-line="53" data-component-end-line="55" data-component-file="TrustIndicators.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xs%20text-muted-foreground%22%7D" className="text-xs text-muted-foreground">
              {indicator.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustIndicators;